import { yumaloq } from "./scale";

export interface BulletBarProps {
	value: number;
	min: number;
	max: number;
	target: number;
	/**
	 * Fon bandlarining ICHKI chegaralari, `[min, max]` shkalasida
	 * (`[70, 85]` → uch band). Chapdan o'ngga to'qlashadi.
	 */
	bands?: number[];
	color: string;
	ariaLabel: string;
	/** Bar balandligi, px (reja imzosidan kengaytirilgan). */
	height?: number;
}

/** Bandlar uchun `--chart-neytral` shaffofligi — chapdagisi eng och. */
const BAND_ULUSHI = [10, 18, 26, 34, 42];

function joy(qiymat: number, min: number, max: number): number {
	const oraliq = max - min;

	if (!(oraliq > 0)) {
		return 0;
	}

	const foiz = ((qiymat - min) / oraliq) * 100;

	return Number.isNaN(foiz) ? 0 : yumaloq(Math.min(100, Math.max(0, foiz)));
}

/**
 * Bullet bar — qiymat, maqsad belgisi va sifat bandlari (sof CSS).
 *
 * ⚠️ **Band chegaralari qisiladi va tartiblanadi** — kengliklar
 * yig'indisi HAR DOIM 100; shkaladan tashqari chegara manfiy kenglik
 * bermaydi.
 *
 * ⚠️ Maqsad belgisi rang emas, vertikal chiziq (ink rangida) — qiymat
 * rangi bilan adashmaydi.
 *
 * ⚠️ `data-bullet-*` — TEST KONTRAKTI.
 */
export function BulletBar({
	value,
	min,
	max,
	target,
	bands = [],
	color,
	ariaLabel,
	height = 10,
}: BulletBarProps) {
	const chegaralar = [0, ...bands.map((b) => joy(b, min, max)).sort((a, b) => a - b), 100];
	const bandlar = chegaralar.slice(1).map((oxiri, i) => {
		const boshi = chegaralar[i] ?? 0;
		return { boshi, kenglik: yumaloq(oxiri - boshi) };
	});

	return (
		<div
			role="img"
			aria-label={ariaLabel}
			className="relative w-full overflow-visible"
			style={{ height: `${height + 6}px` }}
		>
			{bandlar.map((band, i) => (
				<div
					// biome-ignore lint/suspicious/noArrayIndexKey: bandlar tartibi — ularning o'ziga xosligi
					key={i}
					data-bullet-band
					aria-hidden="true"
					className="absolute top-0 bottom-0"
					style={{
						left: `${band.boshi}%`,
						width: `${band.kenglik}%`,
						backgroundColor: `color-mix(in srgb, var(--chart-neytral) ${
							BAND_ULUSHI[Math.min(i, BAND_ULUSHI.length - 1)]
						}%, transparent)`,
					}}
				/>
			))}

			<div
				data-bullet-value
				title={ariaLabel}
				className="absolute left-0 rounded-sm"
				style={{
					top: 3,
					height: `${height}px`,
					width: `${joy(value, min, max)}%`,
					backgroundColor: color,
				}}
			/>

			<div
				data-bullet-target
				aria-hidden="true"
				className="absolute top-0 bottom-0 w-0.5 -translate-x-1/2"
				style={{ left: `${joy(target, min, max)}%`, backgroundColor: "var(--chart-ink)" }}
			/>
		</div>
	);
}
